function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.999 4.5V1h-2.5a1.5 1.5 0 00-1.5 1.5v9a1.5 1.5 0 001.5 1.5H12.5a1.5 1.5 0 001.5-1.5V6h-3.502a1.5 1.5 0 01-1.5-1.5zm1 0V1.25L13.749 5h-3.25a.5.5 0 01-.5-.5zM3 4a1 1 0 011-1v8.5A2.5 2.5 0 006.5 14H12a1 1 0 01-1 1H6.556A3.556 3.556 0 013 11.444V4z",
  fill: "#8F90A6"
});

function SvgCustomForm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgCustomForm;